import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { FidemChat } from '../components/fidem/FidemChat';

// Fidem: NotaryOS's own AI agent, working on the active case with Cerebro, the CRM and fresh norms
export default function FidemPage() {
  const navigate = useNavigate();
  return (
    <div data-testid="fidem-page" className="min-h-screen bg-slate-950 text-white">
      <div className="mx-auto flex min-h-screen max-w-4xl flex-col px-4 pb-44 pt-6 sm:px-6 md:pb-6">
        <button data-testid="fidem-back" onClick={() => navigate(-1)} className="flex items-center gap-2 text-sm text-slate-400 hover:text-white"><ArrowLeft className="h-4 w-4" />Volver</button>
        <div className="mt-3 flex flex-wrap items-end gap-3">
          <h1 className="flex items-center gap-3 text-4xl font-bold tracking-tight sm:text-5xl"><Sparkles className="h-9 w-9 text-amber-400" />Fidem</h1>
          <p className="pb-1 text-sm text-slate-400">El agente de IA de NotaryOS · trabaja con Cerebro, tu CRM y la normativa al día</p>
        </div>
        <FidemChat />
      </div>
    </div>
  );
}
